import styles from "./RadioButton.module.css";

interface Props {
  label?: string;
  checked: boolean;
}

export default function RadioButton({ label, checked }: Props) {
  return (
    <label className={styles.RadioButton} aria-checked={checked}>
      <input type="radio" /> {label}
    </label>
  );
}
